import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './components/Login/Login';
import AddWinningNumber from './components/AddWinningNumber/AddWinning';
import Dashboard from './components/Dashboard';
import ShowWinningNumbers from './components/ShowWinningNumbers/ShowWinning';
import RegisterUser from './Users/Register';
import LoginUser from './Users/LoginUser';
import Navbar from './/Users/Navbar';
import Protected from './utils/Protected';
import PredictNumber from './Users/PredictNumber';
import UserPredictionHistory from './Users/UserPredictionHistory';
import Main from './Users/Main';
import EditUserPredictionNumber from './Users/EditUserPredictionNumber';
import SettingsPage from "./Users/SettingsPage";
import PrizesData from './Users/PrizesData';
import PrivacyPolicy from './Users/PrivacyPolicy';
// import Sidebar from './Sidebar/Sidebar';
// import PhoneSignUp from './Users/PhoneSignUp.jsx';

function App() {
  const userData = localStorage.getItem('userData');

  useEffect(() => {
    const userData = localStorage.getItem('userData');
    if (userData != null) {
      // Function to display a push notification
      const showNotification = () => {
        if ('Notification' in window) {
          Notification.requestPermission()
            .then(permission => {
              if (permission === 'granted') {
                new Notification('Tring Tring', {
                  body: 'Please predict youi',
                });
              }
            })
            .catch(error => {
              console.error('Error requesting notification permission:', error);
            });
        }
      };

      // Calculate the time until the next 10 AM and 8 PM
      const now = new Date();
      const currentHour = now.getHours();
      const timeUntilNextNotification =
        currentHour < 10 ? (10 - currentHour) * 60 * 60 * 1000 : (24 - currentHour + 10) * 60 * 60 * 1000;

      // Schedule the first notification for 10 AM
      setTimeout(() => {
        showNotification();
      }, timeUntilNextNotification);

      // Schedule the second notification for 8 PM (20:00)
      setTimeout(() => {
        showNotification();
      }, timeUntilNextNotification + 10 * 60 * 60 * 1000);

      // Clear notifications when the component unmounts
      return () => {
        // Clear any pending timeouts if the component unmounts
        clearTimeout(timeUntilNextNotification);
      };
    }
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Navbar />
        {/* <Sidebar /> */}
        <Routes>
          {/* <Route path="/" element={<PhoneSignUp />} /> */}
          {userData != null
            ?
            <Route exact path="/" element={<Protected> <PredictNumber /></Protected>} />
            :
            <Route exact path="/" element={<Main />} />
          }
          <Route path="home" element={<Main />} />
          <Route path="prizes" element={<PrizesData />} />
          <Route path="privacy" element={<PrivacyPolicy />} />
          <Route path="user/register" element={<RegisterUser />} />
          <Route path='user/login' element={<LoginUser />} />
          <Route path="user/prediction-number" element={<Protected> <PredictNumber /></Protected>} />
          <Route path="user/edit-prediction-number" element={<Protected> <EditUserPredictionNumber /></Protected>} />
          <Route path="user/history" element={<UserPredictionHistory />} />
          <Route path="user/settings-notification" element={<SettingsPage />} />
          <Route path="admin/login" element={<Login />} />
          <Route path="admin/dashboard" element={<Dashboard />} />
          <Route path="admin/dashboard/addwinningnumber" element={<AddWinningNumber />} />
          <Route path="admin/dashboard/winningnumbersrecords" element={<ShowWinningNumbers />} />
          <Route path="*" element={<h1>Not Found</h1>} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
